$(function(){
    // slider
    var slider = $('.js-slider');
    slider.owlCarousel({
        lazyLoad: true,
        items: 1,
        nav: false,
        dots: false,
        loop: true,
        smartSpeed: 550,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
    });

    // equipment
    var equipment = $('.js-equipment');
    equipment.owlCarousel({
        lazyLoad: true,
        items: 3,
        nav: false,
        dots: true,
        dotsEach: true,
        loop: true,
        margin: 25,
        smartSpeed: 550,
        autoplay: false,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
            1250: {
                items: 3,
            }
        }
    });

    // experts
    var experts = $('.js-experts')
    experts.owlCarousel({
        items: 3,
        nav: true,
        dots: true,
        dotsEach: true,
        loop: true,
        margin: 25,
        smartSpeed: 550,
        autoplay: false,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
            1250: {
                items: 3,
            }
        }
    });

    var portfolio2 = $('.js-portfolio-new');
    portfolio2.owlCarousel({
        lazyLoad: true,
        items: 1,
        nav: true,
        dots: false,
        //loop: true,
        smartSpeed: 550,
        autoplay: false,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
    });
    var indexAll = 0;
    portfolio2.on('translated.owl.carousel', function () {
        portfolio2.parent().find('.js-numbers .active').text($(this).closest('.pf-new-block').find('.active').index() + 1);
        portfolio2.parent().find('.js-numbers .all').text($(this).closest('.pf-new-block').find('.owl-item').length);
        if ($(this).find('.owl-item').last().hasClass('active')) {
            $(this).find('.owl-next').removeClass('disabled').addClass('tofirst');
        } else if ($(this).find('.owl-item').first().hasClass('active')) {
            $(this).find('.owl-prev').removeClass('disabled').addClass('tolast');
            indexAll = $(this).find('.owl-item').length - 1;
        } else {
            $(this).find('.owl-next').removeClass('tofirst');
            $(this).find('.owl-prev').removeClass('tolast');
        }
    });
    $('body').on('click', '.tofirst', function () {
        $(this).removeClass('tofirst');
        portfolio2.trigger('to.owl.carousel', [0, 50, true]);
    });
    $('body').on('click', '.tolast', function () {
        $(this).removeClass('tolast');
        portfolio2.trigger('to.owl.carousel', [indexAll, 50, true]);
    });

    // hide more than 9
    $(".pf-new-block:nth-child(1n+10)").addClass("hidden");

    // show all
    function showMoreCases() {
        $('.pf-new-block.hidden').removeClass("hidden");
    }

    $('.js-pf-new-all').click(function () {
        showMoreCases();
        $(this).fadeOut();
    });

    function pf_ShowPfPopup($pfPopup) {
        $('body').css({'overflow': 'hidden'});
        $('.js-popup-bg').addClass('open'); //show bg

        portfolio2.parent().find('.js-numbers .active').text('1');
        portfolio2.parent().find('.js-numbers .active').text($pfPopup.find('.active').index() + 1);
        portfolio2.parent().find('.js-numbers .all').text($pfPopup.find('.owl-item').length);

        $pfPopup.fadeIn();
        $pfPopup.find('.owl-prev').removeClass('disabled').addClass('tolast');

        $pfPopup.find('img.pf-lazy').lazyload({
            effect: "fadeIn"
        });

        indexAll = $pfPopup.find('.owl-item').length - 1;
    }

    $('.js-more').click(function (e) {
        var $block = $(this).closest(".pf-new-block");
        var hash = $block.prop("id") ? "#" + $block.prop("id") : "";
        if (hash) {
            history.replaceState("", document.title, window.location.pathname + window.location.search + hash);
        }
        pf_ShowPfPopup($block.find(".js-popup"));
        e.preventDefault();
    });
    // emit click js-more when popup is target
    $(window).load(function () {
        var $block = $(".pf-new-block:target");
        if ($block.length) {
            var $popup = $block.find(".js-popup");
            if ($block.hasClass("hidden")) {
                showMoreCases();
            }
            pf_ShowPfPopup($popup);
        }
    });

    // best
    var best = $('.js-best');
    best.owlCarousel({
        lazyLoad: true,
        items: 5,
        nav: true,
        dots: false,
        dotsEach: true,
        dotData: true,
        loop: true,
        smartSpeed: 550,
        autoplay: false,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 3,
            },
            992: {
                items: 5,
            },
            1250: {
                items: 5,
            }
        }
    });

    // reviews
    var reviews = $('.js-reviews');
    reviews.owlCarousel({
        lazyLoad: true,
        items: 4,
        nav: true,
        dots: false,
        dotsEach: true,
        dotData: true,
        loop: true,
        smartSpeed: 550,
        autoplay: false,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 3,
            },
            992: {
                items: 4,
            },
            1250: {
                items: 4,
            }
        }
    });

    // fancybox
    $(".js-fancybox").fancybox({
        openEffect: 'none',
        closeEffect: 'none',
        padding: 0,
        helpers: {
            overlay: {
                locked: true
            }
        }
    });

    // calc

    var Format = {
        price: function (value) {
            return this.format(value, 0, ',', ' ');
        },

        format: function (number, decimals, dec_point, thousands_sep) {
            number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
            var n = !isFinite(+number) ? 0 : +number,
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                s,
                toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + (Math.round(n * k) / k)
                        .toFixed(prec);
                };
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        }
    }
    var areaValues = Array(50, 250, 500, 1000);
    var areaDesc = Array('Корпоративные и домашние залы, залы при отеле.',
        'Корпоративные залы и небольшие фитнес-клубы.',
        'Классические фитнес-клубы.',
        'Большие фитнес-клубы.');
    $("#slider-range-min").slider({
        range: "min",
        value: 1,
        min: 0,
        max: 3,
        slide: function (event, ui) {
            $("#areaAmount").val(areaValues[ui.value]);
            $("#areaAmount").data("indexValue", ui.value);

            $('.calc .dsc1').text(areaDesc[ui.value]);
            $('form.calc').trigger("change");
        }
    });
    var curSliderValue = $("#slider-range-min").slider("value");
    $("#areaAmount").val(areaValues[curSliderValue]).data("indexValue", curSliderValue);
    total();

    $('form.calc').change(function () {
        total();
    });


    function total() {

        var total = 0;
        var eqTypeCost1 = Array(
            Array(217800, 1188400, 2938000, 5387000),
            Array(529300, 1940600, 4873000, 9523000),
            Array(44100, 3838000, 7344000, 15180000)
        );

        var eqTypeCost2 = Array(
            Array(340700, 2332200, 3870000, 7765000),
            Array(790500, 3612000, 6420000, 14610000),
            Array(1318200, 5763900, 8855000, 21400000)
        );

        var eqTypeCost3 = Array(
            Array(146900, 427600, 782000, 1783000),
            Array(198400, 710500, 1320000, 2240000),
            Array(396600, 1472000, 3266000, 7130000)
        );

        var optCost = Array(
            Array(432600, 276400, 242500, 229000, 317600),
            Array(788400, 425400, 376400, 462000, 856000),
            Array(1182000, 635500, 725000, 963000, 1812000)
        );

        var t = Array('Бюджетные, но надежные и качественные линейки тренажеров. Подходят для залов эконом-класса.',
            'Качественное оборудование от мировых брендов с привлекательным дизайном, улучшенной биомеханикой, расширенной гарантией.',
            'Оборудование от мировых лидеров фитнес-индустрии, продумано до мелочей. Широкие возможности индивидуализации.');

        /**/
        var area = $('.calc_b #areaAmount').val();
        var areaIndex = $('.calc_b #areaAmount').data("indexValue");

        var classType = $('.calc_b input[name=type]:checked').val();
        var nap_pok = $('.calc_b input[name=napPok]').prop("checked");

        var kar_tren = $('.calc_b input[name=trenKardio]').prop("checked");
        var sil_tren = $('.calc_b input[name=trenSila]').prop("checked");
        var funk_tren = $('.calc_b input[name=trenFunk]').prop("checked");

        var proect4d = $('.calc_b input[name=dop3]').prop("checked");

        if (nap_pok) {
            total = area * 800;
        }

        if (kar_tren) {
            total += eqTypeCost1[classType][areaIndex];
        }
        if (sil_tren) {
            total += eqTypeCost2[classType][areaIndex];
        }
        if (funk_tren) {
            total += eqTypeCost3[classType][areaIndex];
        }

        $.each($('.calc_b input[name^=opt]'), function (i) {
            if ($(this).prop("checked")) {
                total += optCost[classType][i];
            }
        });

        if (proect4d) {
            total = area * 820 + total
        }


        $('.calc .dsc2').text(t[classType]);
        $('.calc .price span').html(Format.price(total) + ' руб.</span><sup><small>*</small>');

    }

    // add feild_wrapper to form fields
    $('input, select').add('textarea').on('focus', function () {
        $(this).parent()
            .removeClass('wrong');
    }).each(function () {
        if ($(this).data('rules')) {
            $(this).wrap('<div class="feild_wrapper"></div>');
            $(this).parent().append('<span class="error_label"></span>');
        }
    });
});